module.exports = __webpack_public_path__ + "static/media/5.f4ba8e50.png";